import * as React from 'react';

import { string } from 'prop-types';
import { useFormatMessage } from 'react-intl-hooks';

import Html from '@/components/Html';

import Footer from '../Footer';
import HeaderV2 from '../Header';

const Article = ({ articleId }) => {
  const t = useFormatMessage();

  return (
    <div className="page_template">
      <HeaderV2 />
      <section className={`herozone home`}>
        <div className="content_flow">
          <div className="content">
            <div className="col-left">
              <div className="text">
                <h1>{t({ id: `${articleId}.title` })}</h1>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="article text">
        <div className="content">
          <Html value={t({ id: `${articleId}.content` })} />
        </div>
      </section>
      <Footer />
    </div>
  );
};

Article.propTypes = {
  articleId: string,
};

export default Article;
